module.exports = __webpack_public_path__ + "media/bootstrap-icons/linkedin-fe8721c9.svg";